export default "__VITE_ASSET__fY4$BP0___"